<template>
    <div>
        <gmap-map ref="gmap"
            :center="center"
            :zoom="2.2"
            :options="{minZoom: 2}"
            style="margin: auto; width:95%;  min-height: 70vh; border: 1px black solid; border-radius: 1em; overflow: hidden;"
        >

          <gmap-info-window  :position="place.current_position" :opened="showInfo"
          @closeclick="showInfo=false" :options="{pixelOffset: {width: 0, height: -35}}">
            <div v-if="place.current_position">
              <div class="map-info-title">
                <i class="fas fa-globe-americas" aria-hidden="true" style="color: #b8c506" /> <b style="color: #b8c506">Device:</b> {{ place.device_id }}</div>
              <ul class="map-info delayed" :class="place.health">
                <li><b>Current Position</b>
                  <ul>
                    <li><b>- latitude: </b><span>{{ place.current_position.lat }}</span></li>
                    <li><b>- longitude: </b><span>{{ place.current_position.lng }}</span></li>
                  </ul>
                </li>
                <li><b>Register date:</b> 
                  <ul>
                    <li><span>{{ dateToString(new Date(place.current_position.time * 1000)) }}</span></li>
                  </ul>
                </li>
              </ul>
            </div>
          </gmap-info-window>
          <template v-if="shipment && shipment.current_position">
            <gmap-marker
                v-if="shipment"
                :position="{lat: shipment.current_position.lat, lng: shipment.current_position.lng}"
                icon="/static/img/final-point.png"
            ></gmap-marker>
            <gmap-marker
                v-if="shipment && positions && positions.length > 1"
                :position="{lat: positions[positions.length-1].lat, lng: positions[positions.length-1].lng}"
                icon="/static/img/point.png"
            ></gmap-marker>
            <gmap-marker
                v-if="devices && devices.length > 0"
                v-for="(device,index) in devices"
                :key="index"
                :position="{lat: device.current_position.lat, lng: device.current_position.lng}"
                icon="/static/img/point-lime.png"
                @click="setPlace(device)"
                :clickable="true"
            >
            </gmap-marker>
          </template>
            <gmap-polyline v-if="positions && positions.length > 1" v-bind:path.sync="positions" v-bind:options="{ strokeColor:'#009c95', strokeOpacity: 0.7}"/>
            <gmap-polyline
              v-if="devices && devices.length > 0"
              v-for="dev in devices"
              :key="dev.device_id"
             v-bind:path.sync="dev.previous_positions" v-bind:options="{ strokeColor:'#b8c506', strokeOpacity: 0.7}"/>
        </gmap-map>
    </div>
</template>

<script>
import moment from 'moment'
export default {
  name: 'mapLocations',
  props: ['shipment', 'devices'],
  created () {
  },
  mounted () {
    this.$emit('loading')
    this.$refs.gmap.$mapPromise.then((map) => {}).then(() => { this.$emit('loaded') })
  },
  data () {
    return {
      filters: {},
      health: '',
      shipments: [],
      center: { lat: 45.508, lng: -73.587 },
      markerImg: '',
      currentPlace: null,
      place: {},
      showInfo: false
    }
  },
  methods: {
    setBounds () {
      // eslint-disable-next-line
      var bounds = new google.maps.LatLngBounds()
      this.positions.forEach(position => {
        bounds.extend(position)
      })
      this.$refs.gmap.$mapPromise.then((map) => {
        // eslint-disable-next-line
        google.maps.event.addListener(map, 'zoom_changed', () => {
          var zoomChangeBoundsListener =
            // eslint-disable-next-line
            google.maps.event.addListener(map, 'bounds_changed', (event) => {
              if (map.getZoom() > 8 && map.initialZoom) {
                // Change max/min zoom here
                map.setZoom(8)
                map.initialZoom = false
              }
              // eslint-disable-next-line
              google.maps.event.removeListener(zoomChangeBoundsListener)
            })
        })
        map.initialZoom = true
        map.fitBounds(bounds)
      })
    },
    dateToString (value) {
      let dateString = moment(value).format('YYYY-MM-DD HH:MM:ss')
      return value ? dateString : null
    },
    setPlace (dev) {
      this.place = dev
      this.showInfo = true
    }
  },
  computed: {
    positions () {
      let positions = []
      if (this.shipment && this.shipment.previous_positions && this.shipment.previous_positions.length > 1) {
        this.shipment.previous_positions.map((x) => { positions.unshift({lat: x.lat, lng: x.lng}) })
      }
      return positions
    }
  },
  watch: {
    positions () {
      this.setBounds()
    }
  }
}
</script>
<style lang="scss">
.modal-container{
  overflow: auto;
  max-height: 95vh;
}

.map-info {
  border-radius: .4em;
  border: solid black 3px;
  padding: .5em 1em 2em;
  font-size: 1.15em;
  &.delayed {
    border-color: #b8c506;
  }
  &.ontrack {
    border-color: #90be6f;
  }
  &.alerted {
    border-color: #e73857;
  }
  li{
    padding: .2em 0;
  }
}

.map-info-title {
  font-family: MuseoSans-700;
  font-size: 1.3em;
  .delayed {
    color: #b8c506;
  }
  .ontrack {
    color: #90be6f;
  }
  .alerted {
    color: #e73857;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/conventional/ShipmentConventionalMap.vue